import { makeStyles } from '@mui/styles';
import { neutral8, white } from 'apollo-react/colors';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { FixedSizeList as List } from 'react-window';

import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  terminalWrapper: {
    backgroundColor: neutral8,
    margin: 20,
    color: white,
    fontSize: 16,
    overflow: 'auto',
  },
  terminalLog: {
    color: white,
    padding: '0px 20px',
    whiteSpace: 'nowrap',
  },
  logWrapper: {
    display: 'grid',
    alignContent: 'center',
  },
});

const Row = ({ data, index, style }) => {
  const classes = useStyles();
  const log = data[index];

  return (
    <div style={style} title={log} className={classes.logWrapper}>
      <Typography className={classes.terminalLog}>{log}</Typography>
    </div>
  );
};

const TerminalLogs = ({ logs }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return logs.length === 0 ? (
    <div className={classes.terminalWrapper} style={{ padding: 20 }}>
      {translateString('No logs to display')}
    </div>
  ) : (
    <div className={classes.terminalWrapper}>
      <List height={300} itemCount={logs.length} itemSize={40} width="100%" itemData={logs}>
        {Row}
      </List>
    </div>
  );
};

export default TerminalLogs;
